module.exports = __webpack_public_path__ + "static/media/c1bannerModul1_small.ad339a86.jpg";